import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';
import Button from '@nykaa/ui-components/Button';

export const BannerContainer = styled.div<{ bannerGradient: string }>`
  background: ${({ bannerGradient }) => bannerGradient};
  border-radius: ${({ theme }) => theme.borders.radius20};
  display: flex;
  padding: ${({ theme }) => theme.spacing.spacing80};
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  height: 246px;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.spacing200};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 90%;
    margin: ${({ theme }) => theme.spacing.spacing80};
    height: unset;
  }
`;
export const Logo = styled.img`
  height: 34px;
  margin: 0 auto;
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
   @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 24px;
  }
`;
export const BannerProductText = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  display: block;
  text-align: center;
  ${({ theme }) => theme.typography.bodyLarge};
  max-width: 50%;
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
     ${({ theme }) => theme.typography.bodyMedium};
    max-width: 80%;
  }
`;

export const CTAContainer = styled(Button) <{
  borderRadius: string;
  ctaColor: string;
  ctaTextColor: string;
  fillColor?: string;
}>`
  border-radius: ${({ borderRadius }) => borderRadius};
  background-color: ${({ ctaColor }) => ctaColor};
  color: ${({ ctaTextColor }) => ctaTextColor};
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.buttonLarge};
  cursor: pointer;
  border: none;
  width: 100%;
  max-width: 600px;
  word-break: none;
  position: relative;
  overflow: hidden;
  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    min-width: 100%;
    max-width: 300px;
    height: 32px;
    ${({ theme }) => theme.typography.buttonSmall};
  }
`;

export const ProgressFill = styled.div<{ progress: number; fillColor: string }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: ${({ fillColor }) => fillColor || 'rgba(255, 255, 255, 0.32)'};
  transition: width 1s linear;
  z-index: 0;
`;

export const CTAText = styled.span`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SecondaryCTA = styled(CTAContainer) <{ ctaColor: string }>`
  color: ${({ ctaColor }) => ctaColor};
  background-color: transparent;
  margin-bottom: 0;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  &:hover {
    text-decoration: underline;
  }
`;

